import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { LayoutsService } from './core/layouts/layouts.service';
import { SideMenusService } from './core/side-menus/side-menus.service';
import { ChatFireService } from './gen2ai/chatfire.service';
import { firstValueFrom } from 'rxjs';
import { detectDesktopSafariUserAgent } from './shared/safari-main-menu-session';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  private readonly safariBrowserClass = 'safari-browser';

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private breakpointObserver: BreakpointObserver,
    private layoutsService: LayoutsService,
    private sideMenusService: SideMenusService,
    private chatFireService: ChatFireService
  ) { }

  ngOnInit() {
    // Listen to device size changes to dynamically adjust the layout
    if (isPlatformBrowser(this.platformId)) {
      this.toggleSafariBrowserClass();

      // Use Angular CDK Breakpoint Observer to detect changes on the screen size
      this.breakpointObserver.observe([
        Breakpoints.XSmall
      ]).subscribe(result => {
        if (result.breakpoints[Breakpoints.XSmall]) {
          // Switch to mobile layout
          const mobileLayoutName = 'mobile';
          this.layoutsService.switchLayout(mobileLayoutName);
        } else {
          // Switch back to previous layout (or the default one)
          const previousLayoutName = this.layoutsService.previousLayout.name;
          this.layoutsService.switchLayout(previousLayoutName);
        }
      });

      // Clean up conversations older than 30 days on app init
      // Run after a short delay to ensure services are initialized
      setTimeout(() => {
        firstValueFrom(this.chatFireService.deleteOldConversations(30)).catch(err =>
          console.error('Error deleting old conversations (ChatFireService):', err)
        );
      }, 2000);
    }
  }

  private toggleSafariBrowserClass(): void {
    const classList = document.body?.classList;
    if (!classList) {
      return;
    }

    if (this.isSafariBrowser()) {
      classList.add(this.safariBrowserClass);
    } else {
      classList.remove(this.safariBrowserClass);
    }
    this.sideMenusService.recomputeSafariBetaShellMainMenu();
  }

  private isSafariBrowser(): boolean {
    return detectDesktopSafariUserAgent();
  }
}
